import { Box } from '@mui/material';
import { appConfig } from '@/config/appConfig';

export function LoginLogo() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: 0,
      }}
    >
      <Box
        component="img"
        src={appConfig.logoPath}
        alt={appConfig.logoAlt}
        sx={{
          display: 'block',
          height: { xs: 28, sm: 32 },
          width: 'auto',
          maxWidth: '100%',
        }}
      />
    </Box>
  );
}
